// Back off connection failures; one immediate retry handles a locally blocked
// request. Active streams do not expire when their redemption token expires.
const INSTANT_TOKEN_FETCH_FAILURE_MS = 250;
const BACKOFF = { baseDelayMs: 1000, backoffFactor: 2, maxBackoffMs: 15_000 };

export function getTokenFetchRetryDelayMs({
  attempt,
  failureDurationMs,
  config = BACKOFF,
}) {
  const instantFailure =
    typeof failureDurationMs === "number" &&
    failureDurationMs >= 0 &&
    failureDurationMs < INSTANT_TOKEN_FETCH_FAILURE_MS;

  if (attempt <= 1 && instantFailure) {
    return 0;
  }

  return Math.min(
    config.baseDelayMs *
      Math.pow(config.backoffFactor, Math.max(0, attempt - 1)),
    config.maxBackoffMs
  );
}
